module.exports = __webpack_public_path__ + "img/logo.0b7ffa80.png";